import toastMessages from "../helpers/toastMessage";

function teleHeatlhCheckBoxSideEffect(
  checked: boolean,
  setFieldValue: Function,
  setFieldTouched: Function
) {
  setFieldValue("facilityType", `Patient's Home`, true);
  setFieldValue("laboratoryInfo.typeOfSpecimen", "Buccal Swab", true);
  setFieldValue("laboratoryInfo.dateOfCollection", "", true);
  if (checked)
    toastMessages.info(`If this is a telehealth
             order and you'd like your patient to receive alerts about their kit,
             please enter patient email.`);
  setTimeout(() => {
    setFieldTouched("facilityType", true);
    setFieldTouched("laboratoryInfo.typeOfSpecimen", true);
    setFieldTouched("laboratoryInfo.dateOfCollection", true);
  }, 500);
}
export default teleHeatlhCheckBoxSideEffect;
